<template>
    <div class="section pt-0 mt-0">
        <div class="listed-detail mt-3">
            <h3 class="text-center mt-2 mal-text custom-title">{{ pageTitle }}</h3>
        </div>
    </div>

    <div class="section mt-1 mb-1">
        <ul class="nav nav-tabs lined" role="tablist">
            <li class="nav-item">
                <a class="nav-link" :class="{ active: activeTab === 'registrations' }" href="javascript:void(0)" @click="activeTab = 'registrations'">
                    Registration List
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" :class="{ active: activeTab === 'centers' }" href="javascript:void(0)" @click="switchToCentersTab">
                    Exam Centre List
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" :class="{ active: activeTab === 'winners' }" href="javascript:void(0)" @click="switchToWinnersTab">
                    Winners List
                </a>
            </li>
        </ul>
    </div>

    <!-- ============ TAB: Registration List ============ -->
    <template v-if="activeTab === 'registrations'">
        <!-- Filter Section with Accordion -->
        <div class="section inset mt-1 mb-1" v-if="showDistrictFilter || showZoneFilter || showUnitFilter">
            <div class="accordion" id="accordionKnowledgeExamFilter">
                <div class="accordion-item">
                    <h2 class="accordion-header">
                        <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#knowledgeExamFilterAccordion"
                            aria-expanded="false"
                        >
                            <ion-icon name="filter-outline"></ion-icon>
                            Filter
                        </button>
                    </h2>
                    <div
                        id="knowledgeExamFilterAccordion"
                        class="accordion-collapse collapse"
                        :class="hasActiveFilters ? 'show' : ''"
                        data-bs-parent="#accordionKnowledgeExamFilter"
                    >
                        <div class="accordion-body">
                            <div v-if="showDistrictFilter" class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="filter_district">District</label>
                                    <select class="form-control custom-select" v-model="filters.district" @change="onDistrictFilterChange">
                                        <option value="">---All---</option>
                                        <option v-for="d in districtsList" :key="d.id" :value="d.id">{{ d.name }}</option>
                                    </select>
                                </div>
                            </div>

                            <div v-if="showZoneFilter" class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="filter_zone">Zone</label>
                                    <select class="form-control custom-select" v-model="filters.zone" @change="onZoneFilterChange">
                                        <option value="">---All---</option>
                                        <option v-for="z in zonesList" :key="z.id" :value="z.id">{{ z.name }}</option>
                                    </select>
                                </div>
                            </div>

                            <div v-if="showUnitFilter" class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="filter_unit">Unit</label>
                                    <select class="form-control custom-select" v-model="filters.unit">
                                        <option value="">---All---</option>
                                        <option v-for="u in unitsList" :key="u.id" :value="u.id">{{ u.name }}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <button type="button" class="btn btn-danger btn-sm me-1 mb-1" style="width: 100%;" @click="clearFilters">
                                        <ion-icon name="trash-bin-outline"></ion-icon>
                                        Clear
                                    </button>
                                </div>
                                <div class="col-6">
                                    <button type="button" class="btn btn-primary btn-sm me-1 mb-1" style="width: 100%;" @click="applyFilters">
                                        <ion-icon name="search-outline"></ion-icon>
                                        Filter
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="listview-title mt-0 mal-text custom-title">{{ $t('list') || 'ലിസ്റ്റ്' }}</div>

        <!-- Search -->
        <div class="search-section">
            <div class="search-box">
                <div class="input-wrapper">
                    <input
                        type="text"
                        class="form-control search-input"
                        v-model="search_query"
                        @input="handleSearch"
                        placeholder="പേര് / മൊബൈൽ തിരയൂ (Search by name or mobile)"
                        autocomplete="off"
                    />
                    <ion-icon name="search-outline" class="search-icon"></ion-icon>
                    <button type="button" class="clear-search-btn" v-if="search_query" @click="clearSearch">
                        <ion-icon name="close-circle"></ion-icon>
                    </button>
                </div>
            </div>
        </div>

        <div class="section mt-1 mb-1">
            <button type="button" class="btn btn-sm btn-success" style="width: 100%;" :disabled="exportingRegistrations" @click="exportRegistrationsExcel">
                <span v-if="exportingRegistrations" class="spinner-border spinner-border-sm me-1"></span>
                <ion-icon name="download-outline" v-else></ion-icon>
                {{ exportingRegistrations ? 'Exporting...' : 'Export Excel' }}
            </button>
        </div>

        <div class="section text-center" v-if="loading_list">
            <div class="spinner-border text-secondary" role="status"></div>
        </div>

        <div class="section">
            <div class="card">
                <h4 class="text-center mt-1 mal-text error-feedback" v-if="!loading_list && message">{{ message }}</h4>
            </div>
        </div>

        <ul class="listview image-listview inset text" v-if="!loading_list">
            <li v-for="(reg, index) in registrations" :key="reg.id">
                <div class="item-content">
                    <a href="javascript:void(0)" class="item">
                        <span class="sl-no">{{ pagination.from + index }}</span>
                        <img src="assets/img/sample/avatar/avatar1.png" alt="image" class="image" />
                        <div class="in">
                            <div class="min-width-50">
                                <b>{{ reg.name }}</b>
                                <div class="text-secondary small mal-text">{{ reg.parent_name }}</div>
                                <footer class="text-primary">
                                    {{ reg.mobile }}
                                    <span class="mal-text"><br>{{ reg.district_name }} &middot; {{ reg.zone_name }} &middot; {{ reg.unit_name }}</span>
                                    <span class="mal-text"><br>DOB: {{ reg.dob }}</span>
                                    <span v-if="reg.exam_center_name" class="mal-text text-success"><br>Exam Center: {{ reg.exam_center_name }}</span>
                                </footer>
                            </div>
                        </div>
                    </a>

                    <div class="card-button dropdown" @click.stop>
                        <button
                            type="button"
                            class="btn btn-link btn-icon"
                            data-bs-toggle="modal"
                            :data-bs-target="'#actionSheetInset' + reg.id"
                            @click="showActionModel"
                        >
                            <ion-icon name="ellipsis-horizontal"></ion-icon>
                        </button>
                    </div>
                </div>
            </li>
        </ul>

        <div class="section mt-2" v-if="!loading_list">
            <vue-awesome-paginate
                v-if="pagination.total > 0"
                :total-items="pagination.total"
                :items-per-page="pagination.per_page"
                :max-pages-shown="3"
                v-model="pagination.current_page"
                :on-click="handlePageChange"
                :show-ending-buttons="true"
                :show-breakpoint-buttons="false"
            />
        </div>

        <!-- Action Sheet Modals -->
        <div v-for="reg in registrations" :key="'modal-' + reg.id">
            <div class="modal fade action-sheet" :id="'actionSheetInset' + reg.id" tabindex="-1" role="dialog">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">{{ reg.name }}</h5>
                        </div>
                        <div class="modal-body">
                            <ul class="action-button-list">
                                <li>
                                    <a :href="'tel:' + reg.mobile" class="btn btn-list">
                                        <span><ion-icon name="call-outline"></ion-icon> Call</span>
                                    </a>
                                </li>
                                <li class="action-divider"></li>
                                <li>
                                    <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                        <span><ion-icon name="close-outline"></ion-icon> Cancel</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </template>

    <!-- ============ TAB: Exam Centre List ============ -->
    <template v-if="activeTab === 'centers'">
        <div class="section mt-2 mb-1">
            <button type="button" class="btn btn-primary btn-block" @click="openAddCenterModal">
                <ion-icon name="add-outline"></ion-icon> Add Exam Center
            </button>
        </div>

        <div class="section mt-1 mb-1">
            <button type="button" class="btn btn-sm btn-success" style="width: 100%;" :disabled="exportingCenters" @click="exportExamCentersExcel">
                <span v-if="exportingCenters" class="spinner-border spinner-border-sm me-1"></span>
                <ion-icon name="download-outline" v-else></ion-icon>
                {{ exportingCenters ? 'Exporting...' : 'Export Excel' }}
            </button>
        </div>

        <!-- Filter Section with Accordion -->
        <div class="section inset mt-1 mb-1" v-if="showDistrictFilter || showZoneFilter || showUnitFilter">
            <div class="accordion" id="accordionExamCenterFilter">
                <div class="accordion-item">
                    <h2 class="accordion-header">
                        <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#examCenterFilterAccordion"
                            aria-expanded="false"
                        >
                            <ion-icon name="filter-outline"></ion-icon>
                            Filter
                        </button>
                    </h2>
                    <div
                        id="examCenterFilterAccordion"
                        class="accordion-collapse collapse"
                        :class="hasActiveCenterFilters ? 'show' : ''"
                        data-bs-parent="#accordionExamCenterFilter"
                    >
                        <div class="accordion-body">
                            <div v-if="showDistrictFilter" class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="center_filter_district">District</label>
                                    <select class="form-control custom-select" v-model="centerListFilters.district" @change="onCenterFilterDistrictChange">
                                        <option value="">---All---</option>
                                        <option v-for="d in districtsList" :key="d.id" :value="d.id">{{ d.name }}</option>
                                    </select>
                                </div>
                            </div>

                            <div v-if="showZoneFilter" class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="center_filter_zone">Zone</label>
                                    <select class="form-control custom-select" v-model="centerListFilters.zone" @change="onCenterFilterZoneChange">
                                        <option value="">---All---</option>
                                        <option v-for="z in centerFilterZonesList" :key="z.id" :value="z.id">{{ z.name }}</option>
                                    </select>
                                </div>
                            </div>

                            <div v-if="showUnitFilter" class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="center_filter_unit">Unit</label>
                                    <select class="form-control custom-select" v-model="centerListFilters.unit">
                                        <option value="">---All---</option>
                                        <option v-for="u in centerFilterUnitsList" :key="u.id" :value="u.id">{{ u.name }}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <button type="button" class="btn btn-danger btn-sm me-1 mb-1" style="width: 100%;" @click="clearCenterFilters">
                                        <ion-icon name="trash-bin-outline"></ion-icon>
                                        Clear
                                    </button>
                                </div>
                                <div class="col-6">
                                    <button type="button" class="btn btn-primary btn-sm me-1 mb-1" style="width: 100%;" @click="applyCenterFilters">
                                        <ion-icon name="search-outline"></ion-icon>
                                        Filter
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="section text-center" v-if="examCentersLoading">
            <div class="spinner-border text-secondary" role="status"></div>
        </div>

        <div class="section mt-2 mb-2" v-if="!examCentersLoading && !examCenters.length">
            <div class="card">
                <h4 class="text-center mt-1 mal-text error-feedback">പരീക്ഷാ കേന്ദ്രങ്ങൾ ഒന്നും ചേർത്തിട്ടില്ല.</h4>
            </div>
        </div>

        <ul class="listview inset text" v-if="!examCentersLoading && examCenters.length">
            <li v-for="(center, index) in examCenters" :key="center.id">
                <div class="item-content">
                    <a href="javascript:void(0)" class="item">
                        <span class="sl-no">{{ index + 1 }}</span>
                        <div class="in">
                            <div class="min-width-50">
                                <b>{{ center.name }}</b>
                                <footer class="mal-text">
                                    {{ center.district_name }} &middot; {{ center.zone_name }} &middot; {{ center.unit_name }}
                                    <br>Coordinator: {{ center.coordinator_name }}
                                    <br>Invigilator ({{ invigilatorTypeLabel(center.invigilator_type) }}): {{ center.invigilator_display }}
                                    <br>Exam Date: {{ center.exam_date }}
                                    <br>Exam Time: {{ center.exam_time }}
                                    <br><span class="text-secondary" style="font-size: 11px;">Added by: {{ center.added_by_name }} &middot; {{ center.created_at }}</span>
                                </footer>
                            </div>
                        </div>
                    </a>
                    <div class="card-button dropdown" @click.stop>
                        <button
                            type="button"
                            class="btn btn-link btn-icon"
                            data-bs-toggle="modal"
                            :data-bs-target="'#centerActionSheet' + center.id"
                            @click="showActionModel"
                        >
                            <ion-icon name="ellipsis-horizontal"></ion-icon>
                        </button>
                    </div>
                </div>
            </li>
        </ul>

        <!-- Exam Center Action Sheet Modals -->
        <div v-for="center in examCenters" :key="'center-modal-' + center.id">
            <div class="modal fade action-sheet" :id="'centerActionSheet' + center.id" tabindex="-1" role="dialog">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">{{ center.name }}</h5>
                        </div>
                        <div class="modal-body">
                            <ul class="action-button-list">
                                <li>
                                    <a href="javascript:void(0)" @click="openEditCenterModal(center)" class="btn btn-list" data-bs-dismiss="modal">
                                        <span><ion-icon name="create-outline"></ion-icon> Edit</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="javascript:void(0)" @click="confirmDeleteCenter(center)" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                        <span><ion-icon name="trash-outline"></ion-icon> Delete</span>
                                    </a>
                                </li>
                                <li class="action-divider"></li>
                                <li>
                                    <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                        <span><ion-icon name="close-outline"></ion-icon> Cancel</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </template>

    <!-- ============ TAB: Winners List ============ -->
    <template v-if="activeTab === 'winners'">
        <!-- Filter Section with Accordion -->
        <div class="section inset mt-1 mb-1" v-if="showDistrictFilter || showZoneFilter || showUnitFilter">
            <div class="accordion" id="accordionWinnersFilter">
                <div class="accordion-item">
                    <h2 class="accordion-header">
                        <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#winnersFilterAccordion"
                            aria-expanded="false"
                        >
                            <ion-icon name="filter-outline"></ion-icon>
                            Filter
                        </button>
                    </h2>
                    <div
                        id="winnersFilterAccordion"
                        class="accordion-collapse collapse"
                        :class="hasActiveWinnersFilters ? 'show' : ''"
                        data-bs-parent="#accordionWinnersFilter"
                    >
                        <div class="accordion-body">
                            <div v-if="showDistrictFilter" class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="winners_filter_district">District</label>
                                    <select class="form-control custom-select" v-model="winnersFilters.district" @change="onWinnersDistrictFilterChange">
                                        <option value="">---All---</option>
                                        <option v-for="d in districtsList" :key="d.id" :value="d.id">{{ d.name }}</option>
                                    </select>
                                </div>
                            </div>

                            <div v-if="showZoneFilter" class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="winners_filter_zone">Zone</label>
                                    <select class="form-control custom-select" v-model="winnersFilters.zone" @change="onWinnersZoneFilterChange">
                                        <option value="">---All---</option>
                                        <option v-for="z in winnersFilterZonesList" :key="z.id" :value="z.id">{{ z.name }}</option>
                                    </select>
                                </div>
                            </div>

                            <div v-if="showUnitFilter" class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="winners_filter_unit">Unit</label>
                                    <select class="form-control custom-select" v-model="winnersFilters.unit">
                                        <option value="">---All---</option>
                                        <option v-for="u in winnersFilterUnitsList" :key="u.id" :value="u.id">{{ u.name }}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="winners_filter_category">Category</label>
                                    <select class="form-control custom-select" v-model="winnersFilters.category">
                                        <option value="">---All---</option>
                                        <option value="junior">Junior</option>
                                        <option value="senior">Senior</option>
                                    </select>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <button type="button" class="btn btn-danger btn-sm me-1 mb-1" style="width: 100%;" @click="clearWinnersFilters">
                                        <ion-icon name="trash-bin-outline"></ion-icon>
                                        Clear
                                    </button>
                                </div>
                                <div class="col-6">
                                    <button type="button" class="btn btn-primary btn-sm me-1 mb-1" style="width: 100%;" @click="applyWinnersFilters">
                                        <ion-icon name="search-outline"></ion-icon>
                                        Filter
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Search -->
        <div class="search-section">
            <div class="search-box">
                <div class="input-wrapper">
                    <input
                        type="text"
                        class="form-control search-input"
                        v-model="winnersSearchQuery"
                        @input="handleWinnersSearch"
                        placeholder="പേര് / മൊബൈൽ തിരയൂ (Search by name or mobile)"
                        autocomplete="off"
                    />
                    <ion-icon name="search-outline" class="search-icon"></ion-icon>
                    <button type="button" class="clear-search-btn" v-if="winnersSearchQuery" @click="clearWinnersSearch">
                        <ion-icon name="close-circle"></ion-icon>
                    </button>
                </div>
            </div>
        </div>

        <!-- Public mark-entry page open/close toggle — only visible to the two allowed admins -->
        <div class="section mt-1 mb-1" v-if="canToggleMarkEntry">
            <div class="card p-1" style="border-radius:12px;display:flex;flex-direction:row;align-items:center;justify-content:space-between;gap:10px;">
                <div>
                    <div style="font-size:13px;font-weight:700;color:#27173E;">Mark Entry Page</div>
                    <div style="font-size:11px;color:#888;">{{ markEntryOpen ? 'Open — coordinators can submit winners' : 'Closed — showing "Mark Entry time is over"' }}</div>
                </div>
                <button type="button" class="btn btn-sm"
                    :class="markEntryOpen ? 'btn-danger' : 'btn-success'"
                    :disabled="markEntryToggling"
                    style="flex-shrink:0;"
                    @click="toggleMarkEntry">
                    <span v-if="markEntryToggling" class="spinner-border spinner-border-sm"></span>
                    <template v-else>{{ markEntryOpen ? 'Close' : 'Open' }}</template>
                </button>
            </div>
        </div>

        <div class="section mt-1 mb-1">
            <button type="button" class="btn btn-sm btn-success" style="width: 100%;" :disabled="exportingWinners" @click="exportWinnersExcel">
                <span v-if="exportingWinners" class="spinner-border spinner-border-sm me-1"></span>
                <ion-icon name="download-outline" v-else></ion-icon>
                {{ exportingWinners ? 'Exporting...' : 'Export Excel' }}
            </button>
        </div>

        <div class="section text-center" v-if="winnersLoading">
            <div class="spinner-border text-secondary" role="status"></div>
        </div>

        <div class="section" v-if="!winnersLoading">
            <div class="card">
                <h4 class="text-center mt-1 mal-text error-feedback" v-if="winnersMessage">{{ winnersMessage }}</h4>
            </div>
        </div>

        <ul class="listview inset text" v-if="!winnersLoading">
            <li v-for="(entry, index) in winners" :key="entry.id">
                <div class="item-content">
                    <a href="javascript:void(0)" class="item" data-bs-toggle="modal"
                        :data-bs-target="'#winnerEntrySheet' + entry.id" @click="showActionModel">
                        <span class="sl-no">{{ winnersPagination.from + index }}</span>
                        <div class="in">
                            <div class="min-width-50">
                                <div class="winner-card-header">
                                    <b class="winner-card-title">{{ entry.exam_center_name }}</b>
                                    <span class="wc-badge wc-badge-category" v-if="entry.category">{{ entry.category === 'junior' ? 'Junior' : 'Senior' }}</span>
                                    <span class="wc-badge wc-badge-count">{{ entry.winners.length }} Winner{{ entry.winners.length === 1 ? '' : 's' }}</span>
                                </div>
                                <footer class="text-primary winner-card-meta">
                                    <div class="mal-text">{{ entry.district_name }} &middot; {{ entry.zone_name }} &middot; {{ entry.unit_name }}</div>
                                    <div class="mal-text">Attended: {{ entry.students_attended }}</div>
                                    <div class="mal-text">Coordinator: {{ entry.coordinator_name }} ({{ entry.coordinator_mobile }})</div>
                                    <div class="text-secondary winner-card-date">{{ entry.created_at }}</div>
                                </footer>
                            </div>
                        </div>
                    </a>
                    <div class="winner-card-chevron">
                        <ion-icon name="chevron-forward-outline"></ion-icon>
                    </div>
                </div>
            </li>
        </ul>

        <div class="section mt-2" v-if="!winnersLoading">
            <vue-awesome-paginate
                v-if="winnersPagination.total > 0"
                :total-items="winnersPagination.total"
                :items-per-page="winnersPagination.per_page"
                :max-pages-shown="3"
                v-model="winnersPagination.current_page"
                :on-click="handleWinnersPageChange"
                :show-ending-buttons="true"
                :show-breakpoint-buttons="false"
            />
        </div>

        <!-- Winner Entry Detail Sheets — one per center+category submission, listing its
             winners ranked with a medal-style badge (gold/silver/bronze for the top 3). -->
        <div v-for="entry in winners" :key="'winner-modal-' + entry.id">
            <div class="modal fade action-sheet" :id="'winnerEntrySheet' + entry.id" tabindex="-1" role="dialog">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">
                                {{ entry.exam_center_name }}
                                <span class="badge bg-primary ms-1" v-if="entry.category">{{ entry.category === 'junior' ? 'Junior' : 'Senior' }}</span>
                            </h5>
                        </div>
                        <div class="modal-body">
                            <div class="action-sheet-content winner-sheet-content">
                                <ul class="winner-rank-list">
                                    <li class="winner-rank-item" v-for="win in entry.winners" :key="win.id">
                                        <span class="winner-rank-badge" :class="'rank-' + win.position">{{ win.position }}</span>
                                        <div class="winner-rank-info">
                                            <div class="winner-rank-name">
                                                {{ win.name }}
                                                <span class="winner-rank-mark">{{ win.mark }} marks</span>
                                            </div>
                                            <div class="winner-rank-meta mal-text" v-if="win.parent_name">{{ win.parent_name }}</div>
                                            <div class="winner-rank-meta">
                                                <span v-if="win.mobile">{{ win.mobile }}</span>
                                                <span v-if="win.place"> &middot; {{ win.place }}</span>
                                                <span v-if="win.dob"> &middot; DOB: {{ win.dob }}</span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </template>

    <!-- Add Exam Center Modal -->
    <div class="modal fade action-sheet" id="addExamCenterModal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title mal-text">{{ centerForm.id ? 'പരീക്ഷാ കേന്ദ്രം എഡിറ്റ് ചെയ്യുക' : 'പരീക്ഷാ കേന്ദ്രം ചേർക്കുക' }}</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <div class="form-group" v-if="showDistrictFilter">
                            <label class="label">District</label>
                            <select class="form-control custom-select" v-model="centerForm.district_id" @change="onCenterDistrictChange">
                                <option value="">---Select---</option>
                                <option v-for="d in districtsList" :key="d.id" :value="d.id">{{ d.name }}</option>
                            </select>
                        </div>
                        <div class="form-group" v-if="showZoneFilter">
                            <label class="label">Zone</label>
                            <select
                                class="form-control custom-select"
                                v-model="centerForm.zone_id"
                                @change="onCenterZoneChange"
                                :disabled="showDistrictFilter && !centerForm.district_id"
                            >
                                <option value="">---Select---</option>
                                <option v-for="z in centerZonesList" :key="z.id" :value="z.id">{{ z.name }}</option>
                            </select>
                        </div>
                        <div class="form-group" v-if="showUnitFilter">
                            <label class="label">Unit</label>
                            <select class="form-control custom-select" v-model="centerForm.unit_id" :disabled="!centerForm.zone_id">
                                <option value="">---Select---</option>
                                <option v-for="u in centerUnitsList" :key="u.id" :value="u.id">{{ u.name }}</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label class="label">Center Name</label>
                            <input type="text" class="form-control" v-model="centerForm.name" placeholder="Center Name">
                        </div>

                        <div class="form-group">
                            <label class="label">Coordinator Name</label>
                            <input type="text" class="form-control" v-model="centerForm.coordinator_name" placeholder="Name">
                        </div>
                        <div class="form-group">
                            <label class="label">Coordinator Mobile Number</label>
                            <input type="tel" class="form-control" v-model="centerForm.coordinator_mobile" placeholder="Mobile Number">
                        </div>

                        <div class="form-group">
                            <label class="label">Invigilator Type</label>
                            <select class="form-control custom-select" v-model="centerForm.invigilator_type">
                                <option value="">---Select---</option>
                                <option value="madrasa_teacher">Madrasa Teacher</option>
                                <option value="youth">Youth</option>
                                <option value="org">ORG</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label class="label">Invigilator Name</label>
                            <input type="text" class="form-control" v-model="centerForm.invigilator_name" placeholder="Name">
                        </div>
                        <div class="form-group">
                            <label class="label">Invigilator Mobile Number</label>
                            <input type="tel" class="form-control" v-model="centerForm.invigilator_mobile" placeholder="Mobile Number">
                        </div>

                        <div class="form-group">
                            <label class="label">Exam Date</label>
                            <select class="form-control custom-select" v-model="centerForm.exam_date">
                                <option value="" disabled>---Select---</option>
                                <option value="2026-08-15">15 August 2026</option>
                                <option value="2026-08-16">16 August 2026</option>
                                <option value="2026-08-17">17 August 2026</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label class="label">Exam Time</label>
                            <input type="time" class="form-control" v-model="centerForm.exam_time">
                        </div>

                        <p class="error-feedback" v-if="centerFormError">{{ centerFormError }}</p>
                        <button type="button" class="btn btn-primary btn-block btn-lg" :disabled="centerFormSaving" @click="submitExamCenter">
                            <span v-if="centerFormSaving" class="spinner-border spinner-border-sm me-1"></span>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UserService from '../../services/user.service';
import $ from 'jquery';

export default {
    name: 'WisdomExamRegistrationsList',
    data() {
        return {
            user_level: null,
            activeTab: 'registrations',

            // Registration List tab
            loading_list: false,
            message: '',
            search_query: '',
            search_timeout: null,
            registrations: [],
            pagination: { current_page: 1, total: 0, per_page: 20, from: 1 },

            filters: { district: '', zone: '', unit: '' },
            districtsList: [],
            zonesList: [],
            unitsList: [],
            exportingRegistrations: false,

            // Exam Centre List tab
            examCenters: [],
            examCentersLoading: false,
            examCentersLoaded: false,
            centerListFilters: { district: '', zone: '', unit: '' },
            centerFilterZonesList: [],
            centerFilterUnitsList: [],
            exportingCenters: false,

            // Add Exam Center form (separate district/zone/unit lists from the filter above, to
            // avoid the two cascading pickers stomping on each other's state)
            centerForm: {
                id: '',
                district_id: '',
                zone_id: '',
                unit_id: '',
                name: '',
                coordinator_name: '',
                coordinator_mobile: '',
                invigilator_type: '',
                invigilator_name: '',
                invigilator_mobile: '',
                exam_time: '',
                exam_date: '',
            },
            centerZonesList: [],
            centerUnitsList: [],
            centerFormSaving: false,
            centerFormError: '',

            // Winners List tab
            winners: [],
            winnersLoading: false,
            winnersLoaded: false,
            winnersMessage: '',
            winnersSearchQuery: '',
            winnersSearchTimeout: null,
            winnersPagination: { current_page: 1, total: 0, per_page: 20, from: 1 },
            winnersFilters: { district: '', zone: '', unit: '', category: '' },
            winnersFilterZonesList: [],
            winnersFilterUnitsList: [],
            exportingWinners: false,
            markEntryOpen: true,
            markEntryToggling: false,
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        // Same hardcoded-allowlist idiom already used elsewhere in this app (e.g.
        // ReliefNewList.vue's stateEditors) for a short, rarely-changed set of admin mobiles —
        // the backend independently re-checks this same allowlist before honoring a toggle.
        canToggleMarkEntry() {
            if (!this.currentUser) return false;
            const userPhone = String(this.currentUser.phone || this.currentUser.mobile || '');
            return ['9072485752', '9947495218'].includes(userPhone);
        },
        // District field: State only. Zone field: State + District. Unit field: State +
        // District + Zone (never at Unit level — it's already scoped to exactly one unit).
        // Shared by both the registration-list filter accordion and the Add Center form.
        showDistrictFilter() {
            return this.user_level === 1;
        },
        showZoneFilter() {
            return this.user_level === 1 || this.user_level === 2;
        },
        showUnitFilter() {
            return this.user_level === 1 || this.user_level === 2 || this.user_level === 3;
        },
        hasActiveFilters() {
            return this.filters.district || this.filters.zone || this.filters.unit;
        },
        hasActiveCenterFilters() {
            return this.centerListFilters.district || this.centerListFilters.zone || this.centerListFilters.unit;
        },
        hasActiveWinnersFilters() {
            return this.winnersFilters.district || this.winnersFilters.zone || this.winnersFilters.unit || this.winnersFilters.category;
        },
        pageTitle() {
            const level = this.user_level;
            let levelText = '';
            if (level === 1) levelText = 'സ്റ്റേറ്റ്';
            else if (level === 2) levelText = 'ജില്ല';
            else if (level === 3) levelText = 'മണ്ഡലം';
            else if (level === 4) levelText = 'യൂണിറ്റ്';
            return `${levelText ? levelText + ' ' : ''}വിസ്ഡം സ്റ്റുഡന്റ്സ് നോളജ് എക്സാം`;
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
            return;
        }
        this.user_level = parseInt(this.$route.params.sub_level);
        this.loadFilterData();
        this.getRegistrationsList(1);
        if (this.$root.updateParent) {
            this.$root.updateParent('Knowledge Exam');
        }
    },
    methods: {
        showActionModel() {},
        invigilatorTypeLabel(type) {
            if (type === 'madrasa_teacher') return 'Madrasa Teacher';
            if (type === 'youth') return 'Youth';
            if (type === 'org') return 'ORG';
            return type || '-';
        },

        // ---- Excel export (shared by all three tabs) ----
        async downloadExcelBlob(endpoint, payload, filenamePrefix) {
            const response = await UserService.authPostRequest(endpoint, payload, { responseType: 'blob' });
            const blob = response.data;
            const contentType = (response.headers && response.headers['content-type']) || '';
            if (contentType.indexOf('application/json') !== -1) {
                const text = await new Promise((res) => {
                    const r = new FileReader();
                    r.onload = () => res(r.result);
                    r.readAsText(blob);
                });
                let message = 'Export failed.';
                try { message = JSON.parse(text).message || message; } catch (e) { /* keep default */ }
                throw new Error(message);
            }
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${filenamePrefix}-${new Date().toISOString().slice(0, 10)}.xlsx`;
            a.click();
            URL.revokeObjectURL(url);
        },
        async exportRegistrationsExcel() {
            this.exportingRegistrations = true;
            try {
                await this.downloadExcelBlob('wisdom-exam/export-registrations-excel', {
                    sub_level_type: this.user_level,
                    id: this.user_level === 1 ? null : parseInt(this.$route.params.id),
                    q: this.search_query || '',
                    filter_district_id: this.filters.district ? parseInt(this.filters.district) : null,
                    filter_zone_id: this.filters.zone ? parseInt(this.filters.zone) : null,
                    filter_unit_id: this.filters.unit ? parseInt(this.filters.unit) : null,
                }, 'knowledge-exam-registrations');
            } catch (err) {
                window.alert(err.message || 'Export failed.');
            } finally {
                this.exportingRegistrations = false;
            }
        },
        async exportExamCentersExcel() {
            this.exportingCenters = true;
            try {
                await this.downloadExcelBlob('wisdom-exam/export-exam-centers-excel', {
                    sub_level_type: this.user_level,
                    id: this.user_level === 1 ? null : parseInt(this.$route.params.id),
                    filter_district_id: this.centerListFilters.district ? parseInt(this.centerListFilters.district) : null,
                    filter_zone_id: this.centerListFilters.zone ? parseInt(this.centerListFilters.zone) : null,
                    filter_unit_id: this.centerListFilters.unit ? parseInt(this.centerListFilters.unit) : null,
                }, 'knowledge-exam-centers');
            } catch (err) {
                window.alert(err.message || 'Export failed.');
            } finally {
                this.exportingCenters = false;
            }
        },
        async exportWinnersExcel() {
            this.exportingWinners = true;
            try {
                await this.downloadExcelBlob('wisdom-exam/export-winners-excel', {
                    sub_level_type: this.user_level,
                    id: this.user_level === 1 ? null : parseInt(this.$route.params.id),
                    q: this.winnersSearchQuery || '',
                    filter_district_id: this.winnersFilters.district ? parseInt(this.winnersFilters.district) : null,
                    filter_zone_id: this.winnersFilters.zone ? parseInt(this.winnersFilters.zone) : null,
                    filter_unit_id: this.winnersFilters.unit ? parseInt(this.winnersFilters.unit) : null,
                    filter_category: this.winnersFilters.category || null,
                }, 'knowledge-exam-winners');
            } catch (err) {
                window.alert(err.message || 'Export failed.');
            } finally {
                this.exportingWinners = false;
            }
        },

        // ---- Registration List tab ----
        async loadFilterData() {
            try {
                if (this.user_level === 1) {
                    const resp = await UserService.authPostRequest('get-district-by-id', {});
                    this.districtsList = resp.data?.data?.list || [];
                }
                if (this.user_level === 2) {
                    const districtId = parseInt(this.$route.params.id);
                    if (districtId) {
                        const resp = await UserService.authPostRequest('get-zone-by-id', { district_id: districtId });
                        this.zonesList = resp.data?.data?.list || [];
                    }
                }
                if (this.user_level === 3) {
                    const zoneId = parseInt(this.$route.params.id);
                    if (zoneId) {
                        const resp = await UserService.authPostRequest('get-unit-by-id', { zone_id: zoneId });
                        this.unitsList = resp.data?.data?.list || [];
                    }
                }
            } catch (e) {
                // ignore — filter dropdowns just stay empty
            }
        },
        async onDistrictFilterChange() {
            this.filters.zone = '';
            this.filters.unit = '';
            this.zonesList = [];
            this.unitsList = [];
            if (!this.filters.district) return;
            const resp = await UserService.authPostRequest('get-zone-by-id', { district_id: parseInt(this.filters.district) });
            this.zonesList = resp.data?.data?.list || [];
        },
        async onZoneFilterChange() {
            this.filters.unit = '';
            this.unitsList = [];
            if (!this.filters.zone) return;
            const resp = await UserService.authPostRequest('get-unit-by-id', { zone_id: parseInt(this.filters.zone) });
            this.unitsList = resp.data?.data?.list || [];
        },
        applyFilters() {
            this.pagination.current_page = 1;
            this.getRegistrationsList(1);
        },
        clearFilters() {
            this.filters = { district: '', zone: '', unit: '' };
            this.zonesList = this.user_level === 1 ? [] : this.zonesList;
            this.unitsList = this.user_level <= 2 ? [] : this.unitsList;
            this.pagination.current_page = 1;
            this.getRegistrationsList(1);
        },
        getRegistrationsList(page = 1) {
            this.loading_list = true;
            UserService.authPostRequest('wisdom-exam/get-registrations', {
                sub_level_type: this.user_level,
                id: this.user_level === 1 ? null : parseInt(this.$route.params.id),
                page,
                per_page: 20,
                q: this.search_query || '',
                filter_district_id: this.filters.district ? parseInt(this.filters.district) : null,
                filter_zone_id: this.filters.zone ? parseInt(this.filters.zone) : null,
                filter_unit_id: this.filters.unit ? parseInt(this.filters.unit) : null,
            }).then(
                (response) => {
                    this.loading_list = false;
                    if (response.data.status === 'success' && response.data.data && response.data.data.list) {
                        const paginatedList = response.data.data.list;
                        this.registrations = paginatedList.data || [];
                        this.pagination = {
                            current_page: paginatedList.current_page || page,
                            total: paginatedList.total || 0,
                            per_page: paginatedList.per_page || 20,
                            from: paginatedList.from || 1,
                        };
                        this.message = this.registrations.length ? '' : 'രജിസ്ട്രേഷനുകൾ ഒന്നും കണ്ടെത്തിയില്ല.';
                    } else {
                        this.registrations = [];
                        this.message = response.data.message || 'രജിസ്ട്രേഷനുകൾ ഒന്നും കണ്ടെത്തിയില്ല.';
                    }
                },
                () => {
                    this.loading_list = false;
                    this.registrations = [];
                    this.message = 'രജിസ്ട്രേഷനുകൾ ലോഡ് ചെയ്യുന്നതിൽ പിശക്.';
                }
            );
        },
        handlePageChange(page) {
            this.pagination.current_page = page;
            this.getRegistrationsList(page);
        },
        handleSearch() {
            if (this.search_timeout) clearTimeout(this.search_timeout);
            this.search_timeout = setTimeout(() => {
                this.pagination.current_page = 1;
                this.getRegistrationsList(1);
            }, 500);
        },
        clearSearch() {
            this.search_query = '';
            this.pagination.current_page = 1;
            this.getRegistrationsList(1);
        },

        // ---- Exam Centre List tab ----
        switchToCentersTab() {
            this.activeTab = 'centers';
            if (!this.examCentersLoaded) {
                this.loadCenterFilterData();
                this.loadExamCenters();
            }
        },
        async loadCenterFilterData() {
            try {
                if (this.user_level === 2) {
                    const districtId = parseInt(this.$route.params.id);
                    if (districtId) {
                        const resp = await UserService.authPostRequest('get-zone-by-id', { district_id: districtId });
                        this.centerFilterZonesList = resp.data?.data?.list || [];
                    }
                }
                if (this.user_level === 3) {
                    const zoneId = parseInt(this.$route.params.id);
                    if (zoneId) {
                        const resp = await UserService.authPostRequest('get-unit-by-id', { zone_id: zoneId });
                        this.centerFilterUnitsList = resp.data?.data?.list || [];
                    }
                }
            } catch (e) {
                // ignore — filter dropdowns just stay empty
            }
        },
        async onCenterFilterDistrictChange() {
            this.centerListFilters.zone = '';
            this.centerListFilters.unit = '';
            this.centerFilterZonesList = [];
            this.centerFilterUnitsList = [];
            if (!this.centerListFilters.district) return;
            const resp = await UserService.authPostRequest('get-zone-by-id', { district_id: parseInt(this.centerListFilters.district) });
            this.centerFilterZonesList = resp.data?.data?.list || [];
        },
        async onCenterFilterZoneChange() {
            this.centerListFilters.unit = '';
            this.centerFilterUnitsList = [];
            if (!this.centerListFilters.zone) return;
            const resp = await UserService.authPostRequest('get-unit-by-id', { zone_id: parseInt(this.centerListFilters.zone) });
            this.centerFilterUnitsList = resp.data?.data?.list || [];
        },
        applyCenterFilters() {
            this.loadExamCenters();
        },
        clearCenterFilters() {
            this.centerListFilters = { district: '', zone: '', unit: '' };
            this.centerFilterZonesList = this.user_level === 1 ? [] : this.centerFilterZonesList;
            this.centerFilterUnitsList = this.user_level <= 2 ? [] : this.centerFilterUnitsList;
            this.loadExamCenters();
        },
        loadExamCenters() {
            this.examCentersLoading = true;
            UserService.authPostRequest('wisdom-exam/get-exam-centers', {
                sub_level_type: this.user_level,
                id: this.user_level === 1 ? null : parseInt(this.$route.params.id),
                filter_district_id: this.centerListFilters.district ? parseInt(this.centerListFilters.district) : null,
                filter_zone_id: this.centerListFilters.zone ? parseInt(this.centerListFilters.zone) : null,
                filter_unit_id: this.centerListFilters.unit ? parseInt(this.centerListFilters.unit) : null,
            }).then(
                (response) => {
                    this.examCentersLoading = false;
                    this.examCentersLoaded = true;
                    this.examCenters = response.data.status === 'success' ? (response.data.data.list || []) : [];
                },
                () => {
                    this.examCentersLoading = false;
                    this.examCentersLoaded = true;
                    this.examCenters = [];
                }
            );
        },
        resetCenterForm() {
            this.centerForm = {
                id: '',
                district_id: '', zone_id: '', unit_id: '',
                name: '',
                coordinator_name: '', coordinator_mobile: '',
                invigilator_type: '', invigilator_name: '', invigilator_mobile: '',
                exam_time: '',
                exam_date: '',
            };
            this.centerZonesList = [];
            this.centerUnitsList = [];
            this.centerFormError = '';
        },
        async openAddCenterModal() {
            this.resetCenterForm();

            if (this.user_level === 2) {
                this.centerForm.district_id = parseInt(this.$route.params.id);
                await this.onCenterDistrictChange();
            } else if (this.user_level === 3) {
                this.centerForm.zone_id = parseInt(this.$route.params.id);
                await this.onCenterZoneChange();
            } else if (this.user_level === 4) {
                this.centerForm.unit_id = parseInt(this.$route.params.id);
                this.centerForm.zone_id = parseInt(this.currentUser?.zone_id) || '';
            }

            $('#addExamCenterModal').modal('show');
        },
        async openEditCenterModal(center) {
            this.resetCenterForm();
            this.centerForm.id = center.id;
            this.centerForm.name = center.name;
            this.centerForm.exam_time = center.exam_time;
            this.centerForm.exam_date = center.exam_date;

            // Cascading loads first — onCenterDistrictChange/onCenterZoneChange reset
            // zone/unit/coordinator/invigilator as a side effect, so those get set after.
            if (this.user_level === 1) {
                this.centerForm.district_id = center.district_id;
                await this.onCenterDistrictChange();
                this.centerForm.zone_id = center.zone_id;
                await this.onCenterZoneChange();
                this.centerForm.unit_id = center.unit_id;
            } else if (this.user_level === 2) {
                this.centerForm.district_id = center.district_id;
                await this.onCenterDistrictChange();
                this.centerForm.zone_id = center.zone_id;
                await this.onCenterZoneChange();
                this.centerForm.unit_id = center.unit_id;
            } else if (this.user_level === 3) {
                this.centerForm.zone_id = center.zone_id;
                await this.onCenterZoneChange();
                this.centerForm.unit_id = center.unit_id;
            } else if (this.user_level === 4) {
                this.centerForm.unit_id = center.unit_id;
                this.centerForm.zone_id = center.zone_id;
            }

            this.centerForm.coordinator_name = center.coordinator_name || '';
            this.centerForm.coordinator_mobile = center.coordinator_mobile || '';

            this.centerForm.invigilator_type = center.invigilator_type;
            this.centerForm.invigilator_name = center.invigilator_name || '';
            this.centerForm.invigilator_mobile = center.invigilator_mobile || '';

            $('#addExamCenterModal').modal('show');
        },
        confirmDeleteCenter(center) {
            if (!window.confirm('ഈ പരീക്ഷാ കേന്ദ്രം നീക്കം ചെയ്യണോ? (Delete this exam center?)')) return;
            UserService.authPostRequest('wisdom-exam/delete-exam-center', { id: center.id }).then(
                (response) => {
                    if (response.data.status === 'success') {
                        this.loadExamCenters();
                    } else {
                        window.alert(response.data.message || 'Delete failed.');
                    }
                },
                (error) => {
                    window.alert((error.response && error.response.data && error.response.data.message) || 'Delete failed.');
                }
            );
        },
        async onCenterDistrictChange() {
            this.centerForm.zone_id = '';
            this.centerForm.unit_id = '';
            this.centerZonesList = [];
            this.centerUnitsList = [];
            if (!this.centerForm.district_id) return;
            const resp = await UserService.authPostRequest('get-zone-by-id', { district_id: parseInt(this.centerForm.district_id) });
            this.centerZonesList = resp.data?.data?.list || [];
        },
        async onCenterZoneChange() {
            this.centerForm.unit_id = '';
            this.centerUnitsList = [];
            if (!this.centerForm.zone_id) return;
            const resp = await UserService.authPostRequest('get-unit-by-id', { zone_id: parseInt(this.centerForm.zone_id) });
            this.centerUnitsList = resp.data?.data?.list || [];
        },
        submitExamCenter() {
            const f = this.centerForm;
            if (!f.name.trim()) { this.centerFormError = 'Center Name നൽകുക.'; return; }
            if (!f.unit_id) { this.centerFormError = 'Unit തിരഞ്ഞെടുക്കുക.'; return; }
            if (!f.coordinator_name.trim() || !f.coordinator_mobile.trim()) {
                this.centerFormError = 'Coordinator Name, Mobile Number നൽകുക.';
                return;
            }
            if (!f.invigilator_type) { this.centerFormError = 'Center Invigilator തരം തിരഞ്ഞെടുക്കുക.'; return; }
            if (!f.invigilator_name.trim() || !f.invigilator_mobile.trim()) {
                this.centerFormError = 'Invigilator Name, Mobile Number നൽകുക.';
                return;
            }
            if (!f.exam_time) { this.centerFormError = 'Exam Time നൽകുക.'; return; }
            if (!f.exam_date) { this.centerFormError = 'Exam Date തിരഞ്ഞെടുക്കുക.'; return; }

            this.centerFormError = '';
            this.centerFormSaving = true;
            const payload = {
                name: f.name.trim(),
                unit_id: parseInt(f.unit_id),
                coordinator_name: f.coordinator_name.trim(),
                coordinator_mobile: f.coordinator_mobile.trim(),
                invigilator_type: f.invigilator_type,
                invigilator_name: f.invigilator_name.trim(),
                invigilator_mobile: f.invigilator_mobile.trim(),
                exam_time: f.exam_time,
                exam_date: f.exam_date,
            };
            const endpoint = f.id ? 'wisdom-exam/update-exam-center' : 'wisdom-exam/store-exam-center';
            if (f.id) payload.id = parseInt(f.id);
            UserService.authPostRequest(endpoint, payload).then(
                (response) => {
                    this.centerFormSaving = false;
                    if (response.data.status === 'success') {
                        $('#addExamCenterModal').modal('hide');
                        this.loadExamCenters();
                    } else {
                        this.centerFormError = response.data.message || 'സേവ് ചെയ്യാൻ കഴിഞ്ഞില്ല.';
                    }
                },
                (error) => {
                    this.centerFormSaving = false;
                    this.centerFormError = (error.response && error.response.data && error.response.data.message) || error.message || 'സേവ് ചെയ്യാൻ കഴിഞ്ഞില്ല.';
                }
            );
        },

        // ---- Winners List tab ----
        switchToWinnersTab() {
            this.activeTab = 'winners';
            if (!this.winnersLoaded) {
                this.loadWinnersFilterData();
                this.getWinnersList(1);
            }
            if (this.canToggleMarkEntry) {
                this.loadMarkEntryStatus();
            }
        },
        loadMarkEntryStatus() {
            UserService.GetRequest('public/wisdom-exam/mark-entry-status', {}).then(
                (response) => {
                    if (response.data.status === 'success') {
                        this.markEntryOpen = response.data.data.open !== false;
                    }
                },
                () => {}
            );
        },
        toggleMarkEntry() {
            this.markEntryToggling = true;
            UserService.authPostRequest('wisdom-exam/set-mark-entry-status', { open: !this.markEntryOpen }).then(
                (response) => {
                    this.markEntryToggling = false;
                    if (response.data.status === 'success') {
                        this.markEntryOpen = response.data.data.open;
                    }
                },
                () => {
                    this.markEntryToggling = false;
                }
            );
        },
        async loadWinnersFilterData() {
            try {
                if (this.user_level === 1) {
                    const resp = await UserService.authPostRequest('get-district-by-id', {});
                    this.districtsList = resp.data?.data?.list || [];
                }
                if (this.user_level === 2) {
                    const districtId = parseInt(this.$route.params.id);
                    if (districtId) {
                        const resp = await UserService.authPostRequest('get-zone-by-id', { district_id: districtId });
                        this.winnersFilterZonesList = resp.data?.data?.list || [];
                    }
                }
                if (this.user_level === 3) {
                    const zoneId = parseInt(this.$route.params.id);
                    if (zoneId) {
                        const resp = await UserService.authPostRequest('get-unit-by-id', { zone_id: zoneId });
                        this.winnersFilterUnitsList = resp.data?.data?.list || [];
                    }
                }
            } catch (e) {
                // ignore — filter dropdowns just stay empty
            }
        },
        async onWinnersDistrictFilterChange() {
            this.winnersFilters.zone = '';
            this.winnersFilters.unit = '';
            this.winnersFilterZonesList = [];
            this.winnersFilterUnitsList = [];
            if (!this.winnersFilters.district) return;
            const resp = await UserService.authPostRequest('get-zone-by-id', { district_id: parseInt(this.winnersFilters.district) });
            this.winnersFilterZonesList = resp.data?.data?.list || [];
        },
        async onWinnersZoneFilterChange() {
            this.winnersFilters.unit = '';
            this.winnersFilterUnitsList = [];
            if (!this.winnersFilters.zone) return;
            const resp = await UserService.authPostRequest('get-unit-by-id', { zone_id: parseInt(this.winnersFilters.zone) });
            this.winnersFilterUnitsList = resp.data?.data?.list || [];
        },
        applyWinnersFilters() {
            this.winnersPagination.current_page = 1;
            this.getWinnersList(1);
        },
        clearWinnersFilters() {
            this.winnersFilters = { district: '', zone: '', unit: '', category: '' };
            this.winnersFilterZonesList = this.user_level === 1 ? [] : this.winnersFilterZonesList;
            this.winnersFilterUnitsList = this.user_level <= 2 ? [] : this.winnersFilterUnitsList;
            this.winnersPagination.current_page = 1;
            this.getWinnersList(1);
        },
        getWinnersList(page = 1) {
            this.winnersLoading = true;
            this.winnersLoaded = true;
            UserService.authPostRequest('wisdom-exam/get-winners', {
                sub_level_type: this.user_level,
                id: this.user_level === 1 ? null : parseInt(this.$route.params.id),
                page,
                per_page: 20,
                q: this.winnersSearchQuery || '',
                filter_district_id: this.winnersFilters.district ? parseInt(this.winnersFilters.district) : null,
                filter_zone_id: this.winnersFilters.zone ? parseInt(this.winnersFilters.zone) : null,
                filter_unit_id: this.winnersFilters.unit ? parseInt(this.winnersFilters.unit) : null,
                filter_category: this.winnersFilters.category || null,
            }).then(
                (response) => {
                    this.winnersLoading = false;
                    if (response.data.status === 'success' && response.data.data && response.data.data.list) {
                        const paginatedList = response.data.data.list;
                        this.winners = paginatedList.data || [];
                        this.winnersPagination = {
                            current_page: paginatedList.current_page || page,
                            total: paginatedList.total || 0,
                            per_page: paginatedList.per_page || 20,
                            from: paginatedList.from || 1,
                        };
                        this.winnersMessage = this.winners.length ? '' : 'വിജയികളെ ഒന്നും കണ്ടെത്തിയില്ല.';
                    } else {
                        this.winners = [];
                        this.winnersMessage = response.data.message || 'വിജയികളെ ഒന്നും കണ്ടെത്തിയില്ല.';
                    }
                },
                () => {
                    this.winnersLoading = false;
                    this.winners = [];
                    this.winnersMessage = 'വിജയികളെ ലോഡ് ചെയ്യുന്നതിൽ പിശക്.';
                }
            );
        },
        handleWinnersPageChange(page) {
            this.winnersPagination.current_page = page;
            this.getWinnersList(page);
        },
        handleWinnersSearch() {
            if (this.winnersSearchTimeout) clearTimeout(this.winnersSearchTimeout);
            this.winnersSearchTimeout = setTimeout(() => {
                this.winnersPagination.current_page = 1;
                this.getWinnersList(1);
            }, 500);
        },
        clearWinnersSearch() {
            this.winnersSearchQuery = '';
            this.winnersPagination.current_page = 1;
            this.getWinnersList(1);
        },
    },
};
</script>

<style scoped>
.item-content {
    display: flex;
    align-items: center;
    width: 100%;
    position: relative;
    min-height: 60px;
    padding: 8px 0;
}
.item-content .item {
    flex: 1;
    min-width: 0;
    padding-right: 40px;
    /* The framework only gives .item/.in this flex layout under .image-listview (avatar
       lists) — the Exam Centre List and Winners List tabs use a plain avatar-less "listview"
       instead, which leaves .sl-no and .in with no layout rules at all and stacks them
       vertically. Reinstating the same flex row here for both, scoped to this component. */
    display: flex;
    align-items: center;
    padding-top: 11px;
    padding-bottom: 11px;
}
.item-content .item .in {
    display: flex;
    align-items: center;
    width: 100%;
    min-width: 0;
}
.item-content .sl-no {
    flex-shrink: 0;
    margin-right: 12px;
}
.card-button.dropdown {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
}
.search-section {
    padding: 4px 16px 8px 16px;
}
.search-box .input-wrapper {
    position: relative;
}
.search-input {
    padding-left: 36px;
    padding-right: 36px;
}
.search-icon {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #6b7280;
}
.clear-search-btn {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    padding: 4px;
    color: #6b7280;
}

/* Winner List tab — center-level summary card. Chevron is a positioned SIBLING of .item
   (matching .card-button.dropdown above), not a flex child inside it — .item's flex/padding
   rules only exist under .image-listview, which this tab's plain "listview" (no avatar) list
   doesn't have. */
.winner-card-chevron {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--primary, #3b5bdb);
    font-size: 20px;
    line-height: 1;
    pointer-events: none;
}
.winner-card-header {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px 8px;
    margin-bottom: 5px;
}
.winner-card-title {
    font-size: 15px;
    line-height: 1.4;
}
.wc-badge {
    display: inline-flex;
    align-items: center;
    padding: 2px 10px;
    border-radius: 100px;
    font-size: 11px;
    font-weight: 700;
    line-height: 1.7;
    white-space: nowrap;
}
.wc-badge-category {
    background: #e7ecff;
    color: #3b5bdb;
}
.wc-badge-count {
    background: #e6f7ec;
    color: #15803d;
}
.winner-card-meta {
    font-size: 12.5px;
    line-height: 1.65;
}
.winner-card-meta > div {
    margin: 0;
}
.winner-card-date {
    font-size: 11px;
    margin-top: 3px;
}

/* Winner Entry detail sheet — ranked list with a medal-style badge for the top 3. */
.winner-sheet-content {
    max-height: 70vh;
    overflow-y: auto;
}
.winner-rank-list {
    list-style: none;
    margin: 0;
    padding: 0;
}
.winner-rank-item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 4px;
    border-bottom: 1px solid #eee;
}
.winner-rank-item:last-child {
    border-bottom: none;
}
.winner-rank-badge {
    flex-shrink: 0;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 700;
    color: #fff;
    background: #6c757d;
}
.winner-rank-badge.rank-1 {
    background: linear-gradient(135deg, #f7d774, #d4a017);
    box-shadow: 0 2px 6px rgba(212, 160, 23, 0.5);
}
.winner-rank-badge.rank-2 {
    background: linear-gradient(135deg, #dfe4ea, #a4b0be);
    box-shadow: 0 2px 6px rgba(164, 176, 190, 0.5);
}
.winner-rank-badge.rank-3 {
    background: linear-gradient(135deg, #e0a875, #cd7f32);
    box-shadow: 0 2px 6px rgba(205, 127, 50, 0.5);
}
.winner-rank-info {
    flex: 1;
    min-width: 0;
}
.winner-rank-name {
    font-weight: 700;
    font-size: 14.5px;
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 8px;
}
.winner-rank-mark {
    font-size: 12.5px;
    font-weight: 700;
    color: #198754;
    white-space: nowrap;
}
.winner-rank-meta {
    font-size: 12px;
    color: #6b7280;
    margin-top: 2px;
}
</style>
